import ariaLabelsItIT from './ariaLabels/it-IT.json';
import buttonsItIT from './buttons/it-IT.json';
import errorsItIT from './errors/it-IT.json';
import keysItIT from './keys/it-IT.json';
import textsItIT from './texts/it-IT.json';
import tooltipsItIT from './tooltips/it-IT.json';
export default {
    ariaLabels: ariaLabelsItIT,
    errors: errorsItIT,
    tooltips: tooltipsItIT,
    buttons: buttonsItIT,
    texts: textsItIT,
    keys: keysItIT,
};
